var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-page"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('UserData'),_vm._v(" "),_c('Company')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-8"},[_c('OrdersCharts')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51c4ff54","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/src/account/AccountPage.vue
// module id = null
// module chunks = 